module.exports = __webpack_public_path__ + "img/block22.4092c8eb.jpg";